import axios from 'axios';
import { API_URL } from '../../const';

/** ***************** CREATE USER CONTROL DETAILS START *********************** */

// create assign user rights for page
export const createAssignUserRightsForPage = (payloadData: any) => {
	const data = {
		CreateAsignControMenuToken: payloadData,
	};
	const url = `${API_URL}createAsignControlMenu`;
	return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** CREATE USER CONTROL DETAILS END *********************** */

/** ***************** UPDATE USER CONTROL DETAILS START *********************** */

// update assign user rights for page
export const updateAssignUserRightsForPage = (payloadData: any) => {
	const data = {
		UpdateAssignControlMenuToken: payloadData,
	};
	const url = `${API_URL}updateAssignControltoMenu`;
	return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE USER CONTROL DETAILS END *********************** */

/** ***************** SAVE USER CONTROL DETAILS FOR ALL PAGE START *********************** */

// save assign user rights for all page
export const saveAssignUserRightsForAllPage = (payloadData: any) => {
	const data = {
		SaveAssignControForAllPageToken: payloadData,
	};
	const url = `${API_URL}saveAssignControltoAllMenuList`;
	 return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

export const departmentDetailsUpdate = (updateData: JSON) => {
  const data = {
    UpdateDepartmentToken: updateData,
  };
  const url = `${API_URL}UpdateDepartment`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** SAVE USER CONTROL DETAILS FOR ALL PAGE END *********************** */

/** ***************** FETCH USER CONTROL DETAILS START *********************** */

// fetch list user control details - array
export const fetchListUserControlDetails = (fetchListUserControlData: any) => {
	const data = {
		FetchUserControlDetailsToken: fetchListUserControlData,
	};
	const url = `${API_URL}getAllUserControlDetails`;
	return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH USER CONTROL DETAILS END *********************** */
